export default __webpack_public_path__ + "static/everywhere-lab-visit-6-84fc325d09fcf290a6d863552638692d.jpg";